'use client'

import { useState } from 'react'
import { useTranslations } from 'next-intl'
import { X } from 'lucide-react'
import { Button } from '@hello-aria/ui/button'
import { Paragraph } from '@hello-aria/ui/typography'
import { publicEnv } from '@/shared/config/publicEnv'

/**
 * Tells the reader that this makalu is a PM prototype, not the product. Only a `pnpm prototypes deploy` build sets the
 * title, so production never draws it. It sits over the bottom edge rather than in the flow, so it
 * moves no layout. Closing it lasts until the next page load, on purpose: whoever opens the link
 * next must see it again.
 */
export const PrototypeBar = () => {
    const t = useTranslations('root')
    const [isClosed, setIsClosed] = useState(false)
    const title = publicEnv.prototypeTitle

    if (!title || isClosed) return null

    return (
        <div
            role="status"
            className="bg-background-warning border-border-warning fixed inset-x-0 bottom-0 z-50 flex items-center justify-center border-t px-12 py-2"
        >
            <Paragraph tone="warning" weight="medium">
                {t('prototypeBar', { title })}
            </Paragraph>
            <span className="absolute right-3">
                <Button
                    size="square"
                    intent="plain"
                    iconLeft={X}
                    aria-label={t('prototypeBarClose')}
                    onClick={() => setIsClosed(true)}
                />
            </span>
        </div>
    )
}
